import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { UserProvider } from './contexts/UserContext.jsx'
import { useUser } from './hooks/useUser'
import { ConversationProvider } from './contexts/ConversationContext.jsx'
import Layout from './components/Layout'
import ChatPage from './components/ChatPage'
import ManageUsers from './components/ManageUsers'
import TrainingSets from './components/TrainingSets'
import SetPassword from './components/SetPassword'
import Login from './components/Login'
import './resources/scss/app.scss'
import './resources/scss/login.scss'

function AuthChecker({ children }) {
  const { authChecked } = useUser()

  if (!authChecked) {
    return (
      <div className="auth-loading">
        <div>Logging you in...</div>
      </div>
    )
  }

  return children
}

function ProtectedRoute({ children, adminOnly = false }) {
  const { isAdmin } = useUser()

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />
  }

  return children
}

function AppRoutes() {
  return (
    <div className="app">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding" element={<SetPassword />} />
        <Route path="/" element={
          <Layout>
            <ChatPage />
          </Layout>
        } />
        <Route path="/manage-users" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ManageUsers />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/training-sets" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <TrainingSets />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <UserProvider>
      <Router>
        <AuthChecker>
          <ConversationProvider>
            <AppRoutes />
          </ConversationProvider>
        </AuthChecker>
      </Router>
    </UserProvider>
  )
}

export default App
